/*
 * environment (utils)
 */
import { capitalizeFirstLetter } from "./format.utils"

export const AppBuilt = process.env["APP_BUILT"] || Date.now().toString()
export const AppEnv = process.env["APP_ENV"] || "dev"
export const AppPlatform = process.env["APP_PLATFORM"] || "unknown"
export const AppSHA = (process.env["APP_SHA"] || "-").slice(0, 7)
export const AppTitle = process.env["APP_TITLE"] || "Unknown"
export const AppVersion = process.env["APP_VERSION"] || "-"

export const Environment = capitalizeFirstLetter(
	AppEnv === "dev" ? "development" : AppEnv === "prod" ? "production" : AppEnv,
	true,
)

export const isDev = AppEnv === "dev"
export const isProd = AppEnv === "prod"
export const isLocal = process.env["APP_IS_LOCAL"] === "true"
export const isDebug = process.env["APP_DEBUG_MODE"] === "true"
